<template>
  <v-app class="login-page">
    <v-content>
      <v-container class="fill-height align-start" fluid>
        <div class="language-switcher">
          <TheLanguageSwitcher />
        </div>
        <v-row>
          <v-col cols="12" md="6">
            <v-card>
              <div class="login-box">
                <div class="logo-box d-flex justify-center">
                  <img class="logo" src="../assets/logo-main2.png" />
                </div>
                <!-- <v-alert
                                        v-if="errorCredential"
                                        class="alert alert-danger align-center"
                                        color="#fceec4"
                                        prominent
                                        icon="mdi-alert-outline"
                                >
                                    <div class="title">{{ $t('amai') }}</div>
                                    <div>{{ $t('error_credential') }}</div>
                                </v-alert>
                                <v-alert
                                        v-if="errorCredentialAccess"
                                        class="alert alert-danger align-center"
                                        color="#fceec4"
                                        prominent
                                        icon="mdi-alert-outline"
                                >
                                    <div class="title">{{ $t('amai') }}</div>
                                    <div>{{ $t('error_credential_no_access') }}</div>
                                </v-alert> -->

                <v-alert
                  v-if="accessError"
                  class="alert alert-danger align-center"
                  color="#fceec4"
                  prominent
                  icon="mdi-alert-outline"
                >
                  <div class="title">{{ $t("amai") }}</div>
                  <div>{{ accessErrorMessage }}</div>
                </v-alert>

                <v-alert v-if="successAlert" outlined type="success" text>
                  <div>{{ successAlertMessage }}</div>
                </v-alert>

                <v-form @submit="handleSubmit">
                  <div v-if="!isForgotPassword">
                    <div class="label">{{ $t("username") }}</div>
                    <v-text-field
                      outlined
                      height="65"
                      background-color="#f6f9fb"
                      id="email"
                      name="email"
                      v-model="user.email"
                    ></v-text-field>
                    <div v-if="errorEmailRequired" class="alert alert-danger">
                      {{ $t("username_is_required") }}
                    </div>

                    <!-- <div v-if="errorEmailFormat" class="alert alert-danger">{{ $t('email_is_invalid') }}</div> -->
                    <div class="label">{{ $t("password") }}</div>
                    <v-text-field
                      outlined
                      class="passw-input"
                      height="65"
                      background-color="#f6f9fb"
                      :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPass ? 'text' : 'password'"
                      @click:append="showPass = !showPass"
                      v-model="user.password"
                      id="password"
                      name="password"
                    ></v-text-field>
                    <div
                      v-if="errorPasswordRequired"
                      class="alert alert-danger"
                    >
                      {{ $t("password_is_required") }}
                    </div>
                    <div v-if="errorPasswordLength" class="alert alert-danger">
                      {{
                        $t("password_length_characters", {
                          passLength: passwordLength,
                        })
                      }}
                    </div>
                  </div>

                  <div v-if="isForgotPassword">
                    <div class="label">{{ $t("username") }}</div>
                    <v-text-field
                      outlined
                      height="65"
                      background-color="#f6f9fb"
                      id="username"
                      name="username"
                      v-model="forgotPasswordUsername"
                    ></v-text-field>
                    <div
                      v-if="errorUsernameRequired"
                      class="alert alert-danger"
                    >
                      {{ $t("username_is_required") }}
                    </div>

                    <div class="label">{{ $t("email") }}</div>
                    <v-text-field
                      outlined
                      height="65"
                      background-color="#f6f9fb"
                      id="email"
                      name="email"
                      v-model="forgotPasswordEmail"
                    ></v-text-field>
                    <div
                      v-if="errorForgotEmailRequired"
                      class="alert alert-danger"
                    >
                      {{ $t("email_is_required") }}
                    </div>
                  </div>

                  <div class="forgot-password">
                    <span @click="handleClickForgotPassword">
                      {{ isForgotPassword ? $t("back") : $t("forgotPassword") }}
                    </span>
                  </div>

                  <v-btn
                    type="submit"
                    height="65"
                    block
                    dark
                    color="#08a657"
                    class="login-btn"
                  >
                    {{ isForgotPassword ? $t("getPassword") : $t("login") }}
                    <v-avatar size="40" color="rgba(0, 0, 0, 0.15)"
                      ><v-icon medium>mdi-arrow-right</v-icon></v-avatar
                    >
                  </v-btn>
                  <label v-if="!isForgotPassword" class="checkbox">
                    {{ $t("remember_me") }}
                    <input
                      type="checkbox"
                      checked="checked"
                      v-model="user.remember"
                      id="remember"
                      name="remember"
                    />
                    <span class="checkmark"></span>
                  </label>
                </v-form>
                <v-btn
                  v-if="!isForgotPassword"
                  type="button"
                  height="65"
                  block
                  dark
                  color="#08a657"
                  class="login-btn"
                  @click="isShowModalLoginMs = true"
                >
                  {{ $t("login") }} Microsoft
                  <v-icon right> mdi-microsoft </v-icon>
                </v-btn>
              </div>
              <v-divider></v-divider>
              <div class="copyright-box d-flex align-center">
                <div>
                  &copy;
                  {{
                    $t("copyright", {
                      currentYear: this.$store.state.currentYear,
                    })
                  }}
                  | <b>{{ $t("pricvacy_statment") }}</b> {{ $t("in") }}
                  <b>{{ $t("disclaimer") }}</b>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <v-dialog v-model="isShowModalLoginMs" max-width="600px" persistent>
        <v-card>
          <v-card-title class="headline lighten-2" primary-title>
            {{ $t("login") }} Microsoft
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div class="pt-10 pb-10 mb-10">
              <v-text-field
                v-model="microsoftEmail"
                :label="$t('user.email')"
                outlined
                :error="isErrorMicrosoftEmail"
                :error-messages="errorMicrosoftEmail"
              ></v-text-field>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn right text color="primary" @click="closeModalLoginMs">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              right
              text
              color="primary"
              class="ml-5"
              @click="skipAndLoginMS"
            >
              {{ $t("skip") }}
            </v-btn>
            <v-btn
              right
              text
              color="primary"
              class="ml-5"
              @click="checkUserEmail"
            >
              {{ $t("login") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar" :timeout="0" top color="white" text>
        <p style="color: #ff5252">
          {{ text }}
        </p>

        <template>
          <v-btn
            color="#ff5252"
            variant="text"
            outlined
            @click="snackbar = false"
          >
            {{ $t("close") }}
          </v-btn>
        </template>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
import TheLanguageSwitcher from "@/components/TheLanguageSwitcher";
import config from "../config";
import Axios from "axios";
import { i18n } from "@/plugins/i18n";
import router from "@/router";

import { mapMutations } from "vuex";
import { PublicClientApplication } from "@azure/msal-browser";

import { Trans } from '@/plugins/Translation'

import { logout as logOut } from "@/services/logout.js";

const qs = require("querystring");

export default {
  components: {
    TheLanguageSwitcher,
  },
  data() {
    return {
      user: {
        email: "",
        password: "",
        remember: false,
      },
      passwordFieldType: "password",
      errorEmailRequired: false,
      errorEmailFormat: false,
      errorPasswordRequired: false,
      errorPasswordLength: false,
      passwordLength: 50,
      // errorCredential: false,
      // errorCredentialAccess: false,
      showPass: false,
      checkbox: true,

      isShowModalLoginMs: false,
      microsoftEmail: "",
      isErrorMicrosoftEmail: false,
      errorMicrosoftEmail: "",

      snackbar: false,
      text: "",

      accessError: false,
      accessErrorMessage: "",

      successAlert: false,
      successAlertMessage: "",

      isForgotPassword: false,
      forgotPasswordUsername: "",
      errorUsernameRequired: false,
      forgotPasswordEmail: "",
      errorForgotEmailRequired: false,
    };
  },
  async created() {
    this.setDefaultMsalConfig();
  },
  methods: {
    ...mapMutations(["SET_LOGIN_USER", "SET_USER_ORGANIZATIONS"]),

    handleClickForgotPassword() {
      this.accessError = false;
      this.accessErrorMessage = "";
      this.successAlert = false;
      this.successAlertMessage = "";
      this.isForgotPassword = !this.isForgotPassword;
      this.forgotPasswordUsername = "";
      this.forgotPasswordEmail = "";

      this.errorEmailRequired = false;
      this.errorEmailFormat = false;
      this.errorPasswordRequired = false;
      this.errorPasswordLength = false;
      this.errorUsernameRequired = false;
      this.errorForgotEmailRequired = false;
    },

    logout() {
      logOut();
    },

    setDefaultMsalConfig() {
      this.$msalInstance = new PublicClientApplication(config.msalConfig);
    },

    skipAndLoginMS() {
      this.microsoftEmail = "";
      this.isErrorMicrosoftEmail = false;
      this.errorMicrosoftEmail = "";
      this.isShowModalLoginMs = false;

      this.setDefaultMsalConfig();
      this.logInMS();
    },

    checkUserEmail() {
      if (!this.microsoftEmail.trim()) {
        this.isErrorMicrosoftEmail = true;
        this.errorMicrosoftEmail = this.$i18n.t("organization.emptyEmailError");
        return;
      }

      Axios.get(
        config.apiBaseUrl +
          `api/organization/azure-properties?email=${this.microsoftEmail}`
      )
        .then((response) => {
          const msalConfig = JSON.parse(JSON.stringify(config.msalConfig));
          msalConfig.auth.authority = `https://login.microsoftonline.com/${response.data.tenantId}`;
          msalConfig.auth.clientId = response.data.applicationId;

          this.$msalInstance = new PublicClientApplication(msalConfig);
          this.logInMS();
        })
        .catch((error) => {
          this.isErrorMicrosoftEmail = true;
          this.errorMicrosoftEmail = error.response.data;

          /* eslint-disable */
          console.log(error);
        });

      this.isErrorMicrosoftEmail = false;
      this.errorMicrosoftEmail = "";
    },

    closeModalLoginMs() {
      this.microsoftEmail = "";
      this.isErrorMicrosoftEmail = false;
      this.errorMicrosoftEmail = "";
      this.isShowModalLoginMs = false;
    },

    checkUserMSToken(token) {
      const payload = {
        access_token: token,
        state: true,
      };
      Axios.post(config.apiBaseUrl + "microsoft/token", qs.stringify(payload))
        .then((response) => {
          if (response.status === 200) {
            const lang = response.data.language.toLowerCase()
            console.log(lang);
            
            Trans.changeLanguage(lang)
            localStorage.setItem("lang", lang);
            this.setUser(response.data, true);
          }
          if (response.status === 202) {
            this.SET_USER_ORGANIZATIONS(response.data);
            router.push(i18n.locale + "/select-store");
          }
        })
        .catch((error) => {
          // this.errorCredentialAccess = true

          (this.accessError = false),
            (this.accessErrorMessage = this.$i18n.t(
              "error_credential_no_access"
            ));

          localStorage.setItem("loginMS", true);
          this.logout();
          /* eslint-disable */
          console.log("error : ", {
            status: error.response.status,
            statusText: error.response.statusText,
            message: error.response.data,
          });
          this.snackbar = true;
          this.text = error.response.data;
        });
    },

    async logInMS() {
      localStorage.setItem('lang', 'en')

      const loginRequest = { scopes: ["User.Read"] };

      try {
        const loginResponse = await this.$msalInstance.loginPopup(loginRequest);

        if (loginResponse) {
          const accessTokenRequest = {
            scopes: ["User.Read"],
            account: loginResponse.account,
          };

          const accessTokenResponse =
            await this.$msalInstance.acquireTokenSilent(accessTokenRequest);

          let accessToken = accessTokenResponse.accessToken;
          this.checkUserMSToken(accessToken);
        }
      } catch (error) {
        console.error("MSAL Login Error: ", error);
      }
    },

    setUser(userData, ms) {
      localStorage.setItem("userName", userData.username);
      localStorage.setItem("accessToken", userData.access_token);
      localStorage.setItem("role", userData.role);
      localStorage.setItem("userId", userData.userId);
      localStorage.setItem("guid", userData.guid);
      localStorage.setItem("organization", userData.organization);
      localStorage.setItem("organizationId", userData.organizationId);
      localStorage.setItem("permissions", userData.permissions);
      localStorage.setItem(
        "lang",
        userData.language === "" ? "en" : userData.language.toLowerCase()
      );
      localStorage.setItem(
        "showNewDashboardSign",
        userData.showNewDashboardSign === "True" ? "true" : "false"
      );

      if (ms) {
        localStorage.setItem("loginMS", true);
        window.opener && window.opener.location.reload(); // Refresh parent window
        window.close(); // Close the popup
      }

      this.SET_LOGIN_USER(userData);
      router.push(i18n.locale + "/orders");
    },

    handleForgotPasswordSubmit() {
      if (this.isForgotPassword && this.forgotPasswordUsername === "") {
        this.errorUsernameRequired = true;
        return;
      }
      if (this.isForgotPassword && this.forgotPasswordEmail === "") {
        this.errorForgotEmailRequired = true;
        return;
      }

      Axios.get(
        config.apiBaseUrl +
          `password-recovery?login=${this.forgotPasswordUsername}` +
          `&email=${this.forgotPasswordEmail}`
      )
        .then((response) => {
          /* eslint-disable */
          if (response.status === 200) {
            this.successAlert = true;
            this.successAlertMessage = this.$i18n.t("passwordSent");
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.accessError = true;
            this.accessErrorMessage = error.response.data;
          }
        });
      return;
    },

    handleLogInSubmit() {
      if (this.user.email === "") {
        this.errorEmailRequired = true;
        return;
      }

      if (this.user.password === "") {
        this.errorEmailRequired = false;
        this.errorEmailFormat = false;
        this.errorPasswordRequired = true;
        return;
      }

      if (this.user.password.length > this.passwordLength) {
        this.errorEmailRequired = false;
        this.errorEmailFormat = false;
        this.errorPasswordRequired = false;
        this.errorPasswordLength = true;
        return;
      }

      const payload = {
        username: this.user.email,
        password: this.user.password,
        remember: this.user.remember,
      };

      Axios.post(config.apiBaseUrl + "token", qs.stringify(payload))
        .then((response) => {
          /* eslint-disable */
          if (response.status === 200) {
            this.setUser(response.data);
          }
        })
        .catch((error) => {
          if (
            error.response.status === 400 &&
            error.response.data.indexOf("Invalid") !== -1
          ) {
            this.accessError = true;
            this.accessErrorMessage = this.$i18n.t("error_credential");
          } else if (
            error.response.status === 400 &&
            error.response.data.indexOf("access to work") !== -1
          ) {
            this.accessError = true;
            this.accessErrorMessage = this.$i18n.t(
              "error_credential_no_access"
            );
          } else {
            this.accessError = true;
            this.accessErrorMessage = error.response.data;
          }

          /* eslint-disable */
          console.log("error : ", {
            status: error.response.status,
            statusText: error.response.statusText,
            message: error.response.data,
          });
        });
    },

    handleSubmit(e) {
      e.preventDefault();

      this.errorEmailRequired = false;
      this.errorEmailFormat = false;
      this.errorPasswordRequired = false;
      this.errorPasswordLength = false;
      this.errorUsernameRequired = false;
      this.errorForgotEmailRequired = false;

      // this.errorCredential = false;
      // this.errorCredentialAccess = false;

      this.accessError = false;
      this.accessErrorMessage = "";

      this.successAlert = false;
      this.successAlertMessage = "";

      if (this.isForgotPassword) {
        this.handleForgotPasswordSubmit();
      } else {
        this.handleLogInSubmit();
      }
    },
    validEmail: function (email) {
      /* eslint-disable */
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      return re.test(email);
    },
  },
};
</script>
